import React, { useState, Fragment } from "react";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";
import ProspectiveDiseaseList from "./ProspectiveDiseaseList";
import Error from "./Error";
import { groupPostsByLetter } from "../../helpers/groupByLetter";
import AlphabetFilters from "./filters/Alphabet";

const apiUrl = "/wp-json/pan/v1/prospective-disease-funds";

const Prospective = (props) => {
  let activeLetters = [];

  const [letter, setLetter] = useState("");
  const [open, setOpen] = useState(true);
  const [closed, setClosed] = useState(true);
  const [renewalOnly, setRenewalOnly] = useState(true);

  const [loading, response, error] = useGet(apiUrl);

  if (response && !loading) {
    activeLetters = Object.keys(groupPostsByLetter(response.data.data));
  }

  return (
    <Fragment>
      <form className="ListingFilters u-form">
        <div className="l-padding">
          <div className="ListingFilters-wrap l-wrap">
            <AlphabetFilters
              activeLetters={activeLetters}
              setLetters={setLetter}
              letter={letter}
            />
          </div>
        </div>
      </form>

      <div className="l-padding">
        <div className="l-wrap">
          {loading && <Loading label="Searching..." />}

          {response && !loading && (
            <ProspectiveDiseaseList
              letter={letter}
              open={open}
              closed={closed}
              displayStatus={false}
              results={response.data.data}
              noLinks={true}
            />
          )}

          {error && <Error />}
        </div>
      </div>
    </Fragment>
  );
};

export default Prospective;
